import { EventCenter } from './EventCenter'

export interface AiankunAppItem {
  name: string // 唯一ID
  entry?: string // 子应用路径
  credentials?: boolean //拉取 entry 时是否需要携带cookie，详见
  props?: any // 主应用传递给子应用的数据 Object
  port?: string
  url?: string
  tabname?: string
  flatMenu?: boolean
  errorBoundary?: any
}
const entrys: AiankunAppItem[] = [
  {
    name: 'equity',
    port: '6201',
    tabname: '权益',
    flatMenu: true,
  },
  {
    name: 'verification',
    port: '6202',
    tabname: '核销—消费详情-网点',
    flatMenu: true,
  },
  {
    name: 'order',
    port: '6203',
    tabname: '订单',
    flatMenu: true,
  },
  {
    name: 'goods',
    port: '6204',
    tabname: '商品模板',
    flatMenu: true,
  },
  {
    name: 'vvip',
    port: '6205',
    tabname: 'vvip',
    flatMenu: true,
  },
  {
    name: 'limousine',
    port: '6206',
    tabname: 'limousine',
    flatMenu: true,
  },
  {
    name: 'bocom',
    port: '6207',
    tabname: 'bocom',
    flatMenu: true,
  },
  {
    name: 'promo',
    port: '6208',
    tabname: 'promo',
    flatMenu: true,
  },
  {
    name: 'special',
    port: '6209',
    tabname: 'special',
    flatMenu: true,
  },
  {
    name: 'trainmeal',
    port: '6210',
    tabname: 'trainmeal',
    flatMenu: true,
  },
  {
    name: 'ticket',
    port: '6211',
    tabname: 'ticket',
    flatMenu: true,
  },
  {
    name: 'dk',
    port: '6212',
    tabname: 'dk',
    flatMenu: true,
  },
  {
    name: 'chatbot',
    port: '6214',
    tabname: 'chatbot',
    flatMenu: true,
  },
]

// 全局共享的事件中心
export const eventCenter = new EventCenter()

const getQiankunApps = () => {
  // 分享
  type EnvType = 'dev' | 'local' | 'prod'

  const ENV = process.env.ENV as EnvType

  const { hostname } = window.location

  // 各环境微前端url结合
  const entryUrls = {
    prod: `//${hostname}`, // 成产环境
    dev: `//${hostname}`, // 测试环境
    local: `//${hostname}`, // 本地开发环境
    test: `//${hostname}`, // 测试环境
    uat: `//${hostname}`, // uat环境
    'test-ali-pcs': `//${hostname}`, // test-ali-pcs环境
  }

  // 当前环境的微前端url
  const entryUrl = entryUrls[ENV] || `//${hostname}`
  // 子应用路由
  const qiankunApps: AiankunAppItem[] = []

  entrys.forEach((el) => {
    const { name, port, url } = el
    const isLocal =
      hostname.indexOf('localhost') > -1 ||
      hostname.indexOf('192.168') > -1 ||
      hostname.indexOf('10.255') > -1 // 是否本地开发
    let entry = isLocal ? `${entryUrl}:${port}` : `${entryUrl}/${name}`
    if (url) entry = url
    qiankunApps.push({
      name,
      entry,
      props: {
        eventCenter,
      },
    })
  })
  return qiankunApps
}

export { entrys, getQiankunApps }
